/**
 * Generate a short ID from a UUID
 * Takes first 8 characters of UUID for display purposes
 */
export function getShortId(uuid: string): string {
  if (!uuid) return 'N/A';
  return uuid.slice(0, 8).toUpperCase();
}

/**
 * Format ID with prefix for display
 * Example: DRV-E8934548 or TRK-B557757A
 */
export function formatDriverId(uuid: string): string {
  return `DRV-${getShortId(uuid)}`;
}

export function formatTruckId(uuid: string): string {
  return `TRK-${getShortId(uuid)}`;
}

export function formatDispatchId(uuid: string): string {
  return `DIS-${getShortId(uuid)}`;
}

export function formatLoadId(uuid: string): string {
  return `LOAD-${getShortId(uuid)}`;
}
